import { isEmpty } from 'lodash';

/**
 * AU stakeholders will have `address: { country, countryKey, street: "" }`
 * This function will determine if the address object actually has address
 * data in it.
 *
 * @param {object} address
 */
export const hasAddressData = address => {
  const { country, countryKey, ...rest } = address || {};
  return !isEmpty(rest?.street);
};
